import { render, staticRenderFns } from "./kdjs.vue?vue&type=template&id=682c9878&scoped=true&"
import script from "./kdjs.vue?vue&type=script&lang=js&"
export * from "./kdjs.vue?vue&type=script&lang=js&"
import style0 from "./kdjs.vue?vue&type=style&index=0&id=682c9878&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682c9878",
  null
  
)

export default component.exports